import React from 'react';
import Select from 'react-select';
import { Show } from 'Layout';
import { SURVEY_DESCRIPTION_OPTIONS } from './surveyConstants';
import { childProjectNameParts, deriveChildProjectSuffix, composeChildProjectName } from './childProjectName';
import { checkNumberValidation } from 'Helper/Validations';
import Swal from 'sweetalert2';

type Props = {
  state: any;
  setState: (updates: any, cb?: () => void) => void;
  countries: any[];
  selectedCountryOption: any[];
  onCountryChange: (selected: any[]) => void;
  clientOptions: any[];
  pmData: any[];
  options: any[];            // blacklist survey options
  selectedSurveyOptionss: any[];
  isEditMode: boolean;
  onQuotaChange?: (field: string, value: any) => void; // cascades quota to children
  // Per-child "Child Project Name" editing from the parent Project Setup tab.
  // childStates is the single source of truth (same map the child tabs use);
  // childTabs is the rendered per-child list ({ childKey, label, shortName });
  // onChildFieldChange is Form.tsx's updateChildField — writing childProjectName
  // here cascades to the child tab and vice-versa (shared state path).
  childStates?: Record<string, any>;
  childTabs?: Array<{ childKey: string; label: string; shortName: string }>;
  onChildFieldChange?: (childKey: string, field: string, value: any) => void;
};

export class ParentProjectTab extends React.Component<Props> {

  setNumberValidationFields = (e: any, field: string, func?: (e: any) => void) => {
    if (!checkNumberValidation(e) && e.target.value >= 0) {
      this.props.setState({ [field]: e.target.value }, () => {
        if (typeof func === 'function') func(e);
      });
    }
  };

  handleCheckboxValidation = (e: any) => {
    const { name, checked } = e.target;
    this.props.setState({ [name]: checked ? 'Y' : 'N' });
  };

  handleDeviceToggle = (device: 'mobile' | 'desktop' | 'tablet') => {
    const current: string = this.props.state.deviceCompatibility || '';
    const list = current.split(',').map((s: string) => s.trim()).filter(Boolean);
    const next = list.includes(device) ? list.filter((d: string) => d !== device) : [...list, device];
    this.props.setState({ deviceCompatibility: next.join(',') });
  };

  handleBlacklistChange = (selected: any) => {
    this.props.setState({
      blacklistSurvey: selected ? selected.map((o: any) => o.value) : [],
      selectedSurveyOptionss: selected || [],
    });
  };

  check_date_past = (e: any) => {
    const expiryDate = e.target.value;
    const { publishDate, Newdateexpireset } = this.props.state;
    if (publishDate && new Date(expiryDate) < new Date(publishDate)) {
      const modals = document.getElementsByClassName('fade modal show');
      Array.from(modals).forEach((m: any) => { m.style.zIndex = '0'; });
      Swal.fire({
        icon: 'warning',
        title: 'Expired',
        text: 'The expiry date is in the past. Please correct the date',
      }).then(() => {
        Array.from(modals).forEach((m: any) => { m.style.zIndex = ''; });
        this.props.setState({ expiryDate: Newdateexpireset });
      });
    } else {
      this.props.setState({ expiryDate });
      const modals = document.getElementsByClassName('fade modal show');
      Array.from(modals).forEach((m: any) => { m.style.zIndex = ''; });
    }
  };

  calculateCompletePoints = (e: any) => {
    const loiValue = parseInt(e.target.value, 10);
    // This sets default points on parent — children inherit unless overridden
    if (loiValue > 0 && loiValue <= 5) { this.props.setState({ ceggPoints: 15, overquota: 0, terminate: 0 }); }
    else if (loiValue >= 6 && loiValue <= 10) { this.props.setState({ ceggPoints: 25, overquota: 2, terminate: 2 }); }
    else if (loiValue >= 11 && loiValue <= 15) { this.props.setState({ ceggPoints: 35, overquota: 2, terminate: 2 }); }
    else if (loiValue >= 16 && loiValue <= 20) { this.props.setState({ ceggPoints: 45, overquota: 2, terminate: 2 }); }
    else if (loiValue >= 21 && loiValue <= 25) { this.props.setState({ ceggPoints: 55, overquota: 2, terminate: 2 }); }
    else if (loiValue >= 26 && loiValue <= 30) { this.props.setState({ ceggPoints: 65, overquota: 2, terminate: 2 }); }
    else if (loiValue > 30) { this.props.setState({ ceggPoints: 100, overquota: 2, terminate: 2 }); }
    else { this.props.setState({ ceggPoints: 0, overquota: 0, terminate: 0 }); }
  };

  render() {
    const { state, setState, countries, selectedCountryOption, onCountryChange,
      clientOptions, pmData, options, selectedSurveyOptionss, onQuotaChange,
      childStates, childTabs, onChildFieldChange } = this.props;

    return (
      <div>
        {/* Project Name & Project ID */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="projectName">Project Name*</label>
            <input
              className="form-control"
              name="projectName"
              onChange={(e) => setState({ projectName: e.target.value })}
              value={state.projectName}
              placeholder="Enter here"
              required
            />
          </div>
          <div className="col">
            <label htmlFor="projectId">Project ID*</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">DXD-</span>
              </div>
              <input
                type="text"
                className="form-control"
                id="projectId"
                name="projectId"
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, '');
                  if (val.length > 4) val = val.slice(0, 4);
                  setState({ projectId: val ? 'DXD-' + val : '' });
                }}
                value={(state.projectId || '').startsWith('DXD-') ? (state.projectId || '').slice(4) : (state.projectId || '')}
                placeholder="1234"
                maxLength={4}
                pattern="\d{4}"
                required
              />
            </div>
          </div>
        </div>

        {/* Company — hidden; hardcoded to 'Dataxing' on submit */}
        <div className="row mt-2 d-none">
          <div className="col">
            <label htmlFor="company">Company*</label>
            <input
              className="form-control"
              id="company"
              name="company"
              onChange={(e) => setState({ company: e.target.value })}
              value={state.company}
              placeholder="Enter here"
              required
            />
          </div>
          <div className="col d-none">
            <label htmlFor="companyLogo">Logo</label>
            <input
              className="form-control"
              name="companyLogo"
              onChange={(e) => setState({ companyLogo: e.target.value })}
              value={state.companyLogo}
              placeholder="Enter here"
            />
          </div>
        </div>

        {/* Validation checkboxes (left) + Device Compatibility (right, parent-level only) */}
        <div className="row mt-2">
          <div className="col">
            <div className="custom-control custom-control-inline">
              <input
                type="checkbox"
                id="validateStartEndIp"
                name="validateStartEndIp"
                checked={state.validateStartEndIp === 'Y'}
                className="custom-control-input"
                onChange={this.handleCheckboxValidation}
              />
              <label className="custom-control-label" htmlFor="validateStartEndIp">Validate Start-End IP</label>
            </div>
            <div className="custom-control custom-control-inline">
              <input
                type="checkbox"
                id="validateCountry"
                name="validateCountry"
                checked={state.validateCountry === 'Y'}
                className="custom-control-input"
                onChange={this.handleCheckboxValidation}
              />
              <label className="custom-control-label" htmlFor="validateCountry">Validate Country</label>
            </div>
          </div>
          <div className="col">
            <label><strong>Device Compatibility</strong> <small className="text-muted">(which devices this survey supports)</small></label>
            <div>
              <div className="custom-control custom-control-inline">
                <input
                  type="checkbox"
                  id="device-mobile"
                  className="custom-control-input"
                  checked={(state.deviceCompatibility || '').split(',').includes('mobile')}
                  onChange={() => this.handleDeviceToggle('mobile')}
                />
                <label className="custom-control-label" htmlFor="device-mobile">Mobile</label>
              </div>
              <div className="custom-control custom-control-inline">
                <input
                  type="checkbox"
                  id="device-desktop"
                  className="custom-control-input"
                  checked={(state.deviceCompatibility || '').split(',').includes('desktop')}
                  onChange={() => this.handleDeviceToggle('desktop')}
                />
                <label className="custom-control-label" htmlFor="device-desktop">Desktop/Laptop</label>
              </div>
              <div className="custom-control custom-control-inline">
                <input
                  type="checkbox"
                  id="device-tablet"
                  className="custom-control-input"
                  checked={(state.deviceCompatibility || '').split(',').includes('tablet')}
                  onChange={() => this.handleDeviceToggle('tablet')}
                />
                <label className="custom-control-label" htmlFor="device-tablet">Tablet</label>
              </div>
            </div>
          </div>
        </div>

        {/* Pre-screening UI is now per-country — see ChildSurveyTab. */}

        {/* Description & PM Name */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="description">Description*</label>
            <select
              name="description"
              id="description"
              onChange={(e) => setState({ description: e.target.value })}
              value={state.description}
              required
              style={{
                width: '100%', display: 'block', height: '40px', lineHeight: '1.5',
                color: '#495057', backgroundColor: '#fff', backgroundClip: 'padding-box',
                border: '1px solid #ced4da', borderRadius: '5px',
                transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
              }}
            >
              <option value="">--Choose--</option>
              {SURVEY_DESCRIPTION_OPTIONS.map((item, i) => (
                <option key={'desc-' + i} value={'Survey On ' + item}>{item}</option>
              ))}
            </select>
          </div>
          <div className="col">
            <label htmlFor="pmName">PM Name*</label>
            <select
              name="pmName"
              id="pmName"
              // The option value stays the PM's display name so `state.pmName`
              // keeps its existing shape and saved surveys (which store only
              // the name) still preselect. pmId is resolved from pmData and set
              // alongside it — surveys.pmId is the routing key that decides
              // whether the PM receives that survey's notifications.
              onChange={(e) => {
                // Skip the lookup for the "--Choose--" placeholder (value ''):
                // firstName/lastName are NOT NULL but may be empty strings, so a
                // blank-named PM would produce label '' and match the placeholder,
                // clearing pmName while setting that PM's pmId.
                const picked = e.target.value
                  ? pmData.find((item: any) => item.label === e.target.value)
                  : null;
                setState({ pmName: e.target.value, pmId: (picked && picked.userId) || '' });
              }}
              value={state.pmName}
              required
              style={{
                width: '100%', display: 'block', height: '40px', lineHeight: '1.5',
                color: '#495057', backgroundColor: '#fff', backgroundClip: 'padding-box',
                border: '1px solid #ced4da', borderRadius: '5px',
                transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
              }}
            >
              <option value="">--Choose--</option>
              {pmData.map((item, i) => (
                <option key={'pm-' + i} value={item.label}>{item.label}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Survey Status — set on parent, cascades to all non-overridden children */}
        <div className="row mt-3">
          <div className="col">
            <label><strong>Survey Status*</strong> <small className="text-muted">(cascades to all country tabs)</small></label><br />
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="surveyType-parent-test"
                name="surveyType-parent"
                checked={state.surveyType === 'Test'}
                className="custom-control-input"
                onChange={() => {
                  if (onQuotaChange) { onQuotaChange('surveyType', 'Test'); }
                  else { setState({ surveyType: 'Test' }); }
                }}
              />
              <label className="custom-control-label" htmlFor="surveyType-parent-test">Test</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="surveyType-parent-open"
                name="surveyType-parent"
                checked={state.surveyType === 'Open'}
                className="custom-control-input"
                onChange={() => {
                  if (onQuotaChange) { onQuotaChange('surveyType', 'Open'); }
                  else { setState({ surveyType: 'Open' }); }
                }}
              />
              <label className="custom-control-label" htmlFor="surveyType-parent-open">Live</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="surveyType-parent-hold"
                name="surveyType-parent"
                checked={state.surveyType === 'Hold'}
                className="custom-control-input"
                onChange={() => {
                  if (onQuotaChange) { onQuotaChange('surveyType', 'Hold'); }
                  else { setState({ surveyType: 'Hold' }); }
                }}
              />
              <label className="custom-control-label" htmlFor="surveyType-parent-hold">On Hold</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="surveyType-parent-wait"
                name="surveyType-parent"
                checked={state.surveyType === 'Wait'}
                className="custom-control-input"
                onChange={() => {
                  if (onQuotaChange) { onQuotaChange('surveyType', 'Wait'); }
                  else { setState({ surveyType: 'Wait' }); }
                }}
              />
              <label className="custom-control-label" htmlFor="surveyType-parent-wait">Ids Awaited</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                id="surveyType-parent-close"
                name="surveyType-parent"
                checked={state.surveyType === 'Close'}
                className="custom-control-input"
                onChange={() => {
                  if (onQuotaChange) { onQuotaChange('surveyType', 'Close'); }
                  else { setState({ surveyType: 'Close' }); }
                }}
              />
              <label className="custom-control-label" htmlFor="surveyType-parent-close">End</label>
            </div>
          </div>
          <div className="col" />
        </div>

        {/* Client & IR */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="client">Client*</label>
            <Select
              name="client"
              id="client"
              onChange={(val: any) => setState({ client: val })}
              value={state.client}
              required
              options={clientOptions}
            />
          </div>
          <div className="col">
            <label htmlFor="clientir">IR*</label>
            <input
              type="text"
              className="form-control"
              id="clientir"
              name="clientir"
              onChange={(e) => this.setNumberValidationFields(e, 'clientir')}
              value={state.clientir}
              placeholder="Enter here"
              required
              min={0}
              max={100}
            />
          </div>
        </div>

        {/* Survey Length & Speeder Limit */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="surveyLength">Survey Length (in minutes)*</label>
            <input
              type="text"
              className="form-control"
              id="surveyLength"
              name="surveyLength"
              onChange={(e) => this.setNumberValidationFields(e, 'surveyLength', this.calculateCompletePoints)}
              value={state.surveyLength}
              placeholder="Enter here"
              required
              min={0}
            />
          </div>
          <div className="col">
            <label htmlFor="outlierCutoffTime">Speeder Limit (In minutes)*</label>
            <input
              type="text"
              className="form-control"
              id="outlierCutoffTime"
              name="outlierCutoffTime"
              onChange={(e) => this.setNumberValidationFields(e, 'outlierCutoffTime')}
              value={state.outlierCutoffTime}
              placeholder="Enter here"
              required
              min={0}
            />
          </div>
        </div>

        {/* Dates */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="publishDate">Start Date*</label>
            <input
              type="date"
              className="form-control"
              name="publishDate"
              onChange={(e) => setState({ publishDate: e.target.value })}
              value={state.publishDate}
              placeholder="Enter here"
              min={new Date().toISOString().split('T')[0]}
              required
            />
          </div>
          <div className="col">
            <label htmlFor="expiryDate">End Date*</label>
            <input
              type="date"
              className="form-control"
              id="expiryDate"
              name="expiryDate"
              onChange={this.check_date_past}
              value={state.expiryDate}
              placeholder="Enter here"
              min={state.publishDate || new Date().toISOString().split('T')[0]}
              required
            />
          </div>
        </div>

        {/* Cost & Currency */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="costPerInterview">Cost Per Interview*</label>
            <input
              type="number"
              className="form-control"
              name="costPerInterview"
              onChange={(e) => setState({ costPerInterview: e.target.value })}
              value={state.costPerInterview}
              placeholder="Enter here"
              required
              step="any"
              min={0}
            />
          </div>
          <div className="col">
            <label htmlFor="currency">Currency*</label>
            <input
              type="text"
              className="form-control"
              name="currency"
              onChange={(e) => setState({ currency: e.target.value })}
              value={state.currency}
              placeholder="Enter here"
              required
            />
          </div>
        </div>

        {/* Exclude Survey & URL Identifier */}
        <div className="row mt-2">
          <div className="col">
            <label htmlFor="excludeSurvey">Exclude Survey Completes</label>
            <Select
              name="state"
              id="state"
              onChange={this.handleBlacklistChange}
              value={selectedSurveyOptionss}
              isMulti
              options={options}
            />
          </div>
          <div className="col">
            <label htmlFor="surveyUrlIdentifier">Survey URL Identifier*</label>
            <input
              className="form-control"
              id="surveyUrlIdentifier"
              name="surveyUrlIdentifier"
              onChange={(e) => setState({ surveyUrlIdentifier: e.target.value })}
              value={state.surveyUrlIdentifier}
              placeholder="Enter here"
              required
            />
          </div>
        </div>

        {/* Country Selection — creates child tabs */}
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="country"><strong>Countries*</strong> <small className="text-muted">(each selected country creates a child survey tab)</small></label>
            <Select
              name="countryTitle"
              id="countryTitle"
              onChange={onCountryChange}
              value={selectedCountryOption}
              required
              options={countries}
              getOptionValue={(o: any) => o.id ? String(o.id) : o.nonce ? ('new:' + o.shortName + ':' + o.nonce) : o.value}
              isMulti
            />
          </div>
        </div>

        {/* Child Project Names — one editable input per child. Backed by the same
            childStates[childKey].childProjectName the child country tabs use, so
            edits here cascade to the child tab and vice-versa (single source of
            truth via onChildFieldChange = Form.tsx updateChildField). */}
        {Array.isArray(childTabs) && childTabs.length > 0 && onChildFieldChange && (
          <div className="row mt-3">
            <div className="col">
              <label><strong>Child Project Names</strong> <small className="text-muted">(one per country tab; edits sync with the country tab)</small></label>
              {childTabs.map((tab) => (
                <div className="row mt-2" key={`cpn-${tab.childKey}`}>
                  <div className="col-3 d-flex align-items-center">
                    <span>{tab.label}</span>
                  </div>
                  <div className="col-3">
                    {(() => {
                      // Per-child Client Quota — PM-entered, required, minimum 1.
                      // Parent's own Client Quota (below, in this same tab) is a
                      // derived, read-only sum of these values; the backend
                      // recomputes it via recomputeParentClientQuota() on every
                      // write that can change the set or values of children.
                      const childQuotaRaw = childStates && childStates[tab.childKey]
                        ? childStates[tab.childKey].userLimitCommitted
                        : undefined;
                      const childQuotaInvalid = childQuotaRaw === undefined || childQuotaRaw === null || childQuotaRaw === ''
                        || !Number.isFinite(Number(childQuotaRaw)) || Number(childQuotaRaw) < 1;
                      return (
                        <>
                          <input
                            type="number"
                            min={1}
                            className={`form-control${childQuotaInvalid ? ' is-invalid' : ''}`}
                            name={`userLimitCommitted-${tab.childKey}`}
                            value={childQuotaRaw ?? ''}
                            placeholder="Client Quota*"
                            onChange={(e: any) => {
                              const val = e.target.value === '' ? '' : Number(e.target.value);
                              if (onChildFieldChange) onChildFieldChange(tab.childKey, 'userLimitCommitted', val);
                            }}
                          />
                          {childQuotaInvalid && (
                            <small className="text-danger d-block">Required, minimum 1.</small>
                          )}
                        </>
                      );
                    })()}
                  </div>
                  <div className="col-6">
                    {(() => {
                      // Locked prefix = `${parentProjectName}_${countryCode}_` rendered in
                      // BOTH create and edit modes. PM edits only the suffix; combined
                      // `${prefix}${suffix}` (or bare base when suffix is empty) is written
                      // back to childStates[childKey].childProjectName so the sibling
                      // per-country tab stays in sync via the same shared state path.
                      // In create mode the prefix updates live as the parent projectName
                      // is typed (Form.tsx setParentState cross-updates each row's stored
                      // value to match the new prefix while preserving the suffix portion).
                      // Split/compose live in childProjectName.ts — shared with
                      // ChildSurveyTab.tsx so the two inputs behave identically.
                      // The suffix is never trimmed on the read path (spaces the PM
                      // types must survive to the next render); whitespace is
                      // normalized once, at submit, in Form.formValues().
                      const parentName = (state && (state.parentProjectName || state.projectName)) || '';
                      const countryCode = tab.shortName || '';
                      const { prefix: lockedPrefix } = childProjectNameParts(parentName, countryCode);
                      const current = ((childStates && childStates[tab.childKey] && childStates[tab.childKey].childProjectName) || '') as string;
                      const suffix = deriveChildProjectSuffix(current, parentName, countryCode);
                      const handleSuffixChange = (e: any) => {
                        const newFull = composeChildProjectName(parentName, countryCode, e.target.value);
                        onChildFieldChange(tab.childKey, 'childProjectName', newFull);
                      };
                      return (
                        <div className="input-group">
                          <span className="input-group-text" style={{ userSelect: 'none' }}>
                            {lockedPrefix}
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            name={`childProjectName-${tab.childKey}`}
                            value={suffix}
                            onChange={handleSuffixChange}
                            placeholder="optional suffix"
                          />
                        </div>
                      );
                    })()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Client Quota — read-only, derived. Each child now holds its own
            PM-entered quota (above); this is the live sum, recomputed here for
            display and by the backend (recomputeParentClientQuota) on save. */}
        <div className="row mt-3">
          <div className="col">
            <label htmlFor="userLimitCommitted"><strong>Client Quota</strong> <small className="text-muted">(total of all child project quotas)</small></label>
            <input
              type="text"
              className="form-control"
              id="userLimitCommitted"
              name="userLimitCommitted"
              value={(childTabs || []).reduce((total: number, tab: any) => {
                const v = childStates && childStates[tab.childKey] ? Number(childStates[tab.childKey].userLimitCommitted) : 0;
                return total + (Number.isFinite(v) ? v : 0);
              }, 0)}
              placeholder="Enter here"
              disabled
              readOnly
            />
          </div>
          <div className="col" />
        </div>

        {/* Hidden fields preserved for backward compat */}
        <div className="row mt-2 d-none">
          <div className="col">
            <label>Description One</label>
            <input className="form-control" onChange={(e) => setState({ description_one: e.target.value })} value={state.description_one} placeholder="Enter here" />
          </div>
        </div>
        <div className="row mt-2 d-none">
          <div className="col">
            <label>Description Two</label>
            <input className="form-control" onChange={(e) => setState({ description_two: e.target.value })} value={state.description_two} placeholder="Enter here" />
          </div>
        </div>
        <div className="row mt-2 d-none">
          <div className="col">
            <label>Description Three</label>
            <input className="form-control" onChange={(e) => setState({ description_three: e.target.value })} value={state.description_three} placeholder="Enter here" />
          </div>
        </div>
        <div className="row mt-2 d-none">
          <div className="col">
            <label>Description Four</label>
            <input className="form-control" onChange={(e) => setState({ description_four: e.target.value })} value={state.description_four} placeholder="Enter here" />
          </div>
        </div>
        <div className="row mt-2 d-none">
          <div className="col">
            <label>Color Code</label>
            <input className="form-control" onChange={(e) => setState({ colorCode: e.target.value })} value={state.colorCode} placeholder="Enter here" />
          </div>
        </div>

        {/*
          Country-Specific Settings (DX Quota, Send Survey, Points, Disclaimer, etc.)
          intentionally live in ChildSurveyTab.tsx (the per-country tab), not in
          Project Setup. See BUGFIX_LOG_COUNTRY_SETTINGS.md (2026-04-20).
        */}
      </div>
    );
  }
}
